import React from 'react';

export const ViewAllIcon = () => {
    return (
        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 13L7 7L1 0.999999" stroke="black" strokeWidth="2" />
        </svg>
    );
};
